export const locale = {
    lang: 'es',
    data: {
        CLINIC_MESSAGE_NOTIFICATION: {
            DATE_FORMAT: 'dd/MM/yyyy',
            EMPTY: 'No tienes mensajes',
            EMPTY_PATIENT: 'Paciente no definido',
            VIEW_ALL: 'Ver todas',
            VIEW_UNREAD: 'Ver no leídas',
            MAKE_AS_READ: 'Marcar como leídos',
            GO_TO_MESSAGE: 'Ir al chat del cliente',
            GO_TO_CHAT: 'Ir al chat',
            REMAKE_TYPE: {
                REMAKE: 'Repetición',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Ajuste',
                ADJUSTMENT_INITIAL: 'A',
            },
        },
    },
};
